import React, { useEffect, useState } from "react";
import { T } from "../Translate";
import { isValidPhone } from "../../utils/contactLinks";
import {
  Container,
  AppBar,
  Toolbar,
  Typography,
  CircularProgress,
  Skeleton,
  TextField,
  MenuItem,
  Grid,
  Box,
  CardMedia,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Select,
  Alert,
  FormHelperText,
  Card,
  CardContent,
  CardActions,
  Chip,
  Stack,
  InputAdornment,
} from "@mui/material";
import {
  collection,
  onSnapshot,
  query,
  where,
  deleteDoc,
  doc,
  updateDoc,
  getDoc,
} from "firebase/firestore";
import { auth, db, getToken, uploadImage } from "../../firebase";
import { AddPhotoAlternate as AddPhotoAlternateIcon } from "../../icons";
import { Search as SearchIcon } from "../../icons";
import { Edit as EditIcon } from "../../icons";
import { Delete as DeleteIcon } from "../../icons";
import { DirectionsCar as DirectionsCarIcon } from "../../icons";
import { isLoggedIn } from "../../session";
import Atras from "../BackButton";
import BottomNav from "../BottomToolbar";
import { brandColors, barColors } from "../../theme";
import { pageContentSx } from "../../pageLayout";
import { uploadButtonSx, uploadProgressSx } from "../mediaFormStyles";
import SortableImageGrid from "../../components/SortableImageGrid";
import FeatureListingButton from "../../components/FeatureListingButton";

import SearchClearAdornment from "../../components/SearchClearAdornment";
const CONDITION_STYLES = {
  Nuevo: { color: "#4a90e2", bgcolor: "rgba(74,144,226,0.16)", label: <T>Nuevo</T> },
  Usado: { color: "#50e3c2", bgcolor: "rgba(80,227,194,0.16)", label: <T>Usado</T> },
  Reparar: { color: "#ed8936", bgcolor: "rgba(237,137,54,0.16)", label: <T>Para reparar</T> },
};

const CAR_FORM_VALIDATION = {
  whatsapp: {
    validate: (value) =>
      value && !isValidPhone(value) ? <T>Ingresá un número válido con código de país (ej: +5491122334455)</T> : "",
  },
  title: {
    required: true,
    minLength: 5,
    maxLength: 100,
    validate: (value) => {
      if (!value) return <T>El título es obligatorio</T>;
      if (value.length < 5) return <T>El título debe tener al menos 5 caracteres</T>;
      if (value.length > 100) return <T>El título no puede exceder 100 caracteres</T>;
      return "";
    },
  },
  description: {
    required: true,
    minLength: 20,
    maxLength: 1000,
    validate: (value) => {
      if (!value) return <T>La descripción es obligatoria</T>;
      if (value.length < 20) return <T>La descripción debe tener al menos 20 caracteres</T>;
      if (value.length > 1000) return <T>La descripción no puede exceder 1000 caracteres</T>;
      return "";
    },
  },
  price: {
    required: true,
    validate: (value) => {
      if (!value) return <T>El precio es obligatorio</T>;
      if (isNaN(value) || value <= 0) return <T>El precio debe ser un número válido mayor que 0</T>;
      return "";
    },
  },
  city: {
    required: true,
    validate: (value) => {
      if (!value) return <T>La ciudad es obligatoria</T>;
      if (value.length < 2) return <T>El nombre de la ciudad es demasiado corto</T>;
      return "";
    },
  },
  marca: {
    required: true,
    validate: (value) => {
      if (!value) return <T>La marca es obligatoria</T>;
      return "";
    },
  },
  modelo: {
    required: true,
    validate: (value) => {
      if (!value) return <T>El modelo es obligatorio</T>;
      if (value.length < 2) return <T>El modelo debe tener al menos 2 caracteres</T>;
      return "";
    },
  },
  año: {
    required: true,
    validate: (value) => {
      if (!value) return <T>El año es obligatorio</T>;
      const year = parseInt(value);
      const currentYear = new Date().getFullYear();
      if (isNaN(year) || year < 1900 || year > currentYear + 1)
        return <T>El año debe estar entre 1900 y {currentYear + 1}</T>;
      return "";
    },
  },
  km: {
    required: true,
    validate: (value) => {
      if (!value) return <T>El kilometraje es obligatorio</T>;
      if (isNaN(value) || value < 0) return <T>El kilometraje debe ser un número válido</T>;
      return "";
    },
  },
  condition: {
    required: true,
    validate: (value) => {
      if (!value) return <T>La condición es obligatoria</T>;
      const validConditions = ["Nuevo", "Usado", "Reparar"];
      if (!validConditions.includes(value)) return <T>Seleccione una condición válida</T>;
      return "";
    },
  },
  images: {
    required: true,
    validate: (value) => {
      if (!Array.isArray(value) || value.length === 0) return <T>Debe mantener al menos una imagen</T>;
      if (value.length > 10) return <T>No puede tener más de 10 imágenes</T>;
      return "";
    },
  },
};

const Marcas = [
  "Acura",
  "Alfa Romeo",
  "Aston Martin",
  "Audi",
  "Bentley",
  "BMW",
  "Bugatti",
  "Buick",
  "BYD",
  "Cadillac",
  "Changan",
  "Chery",
  "Chevrolet",
  "Chrysler",
  "Citroën",
  "Dodge",
  "DS",
  "Ferrari",
  "Fiat",
  "Ford",
  "Genesis",
  "GMC",
  "Great Wall",
  "Honda",
  "Hyundai",
  "Infiniti",
  "Isuzu",
  "Jaguar",
  "Jeep",
  "Kia",
  "Lada",
  "Lamborghini",
  "Land Rover",
  "Lexus",
  "Maserati",
  "Mazda",
  "McLaren",
  "Mercedes Benz",
  "Mini",
  "Mitsubishi",
  "Nissan",
  "Opel",
  "Peugeot",
  "Porsche",
  "RAM",
  "Renault",
  "Rolls-Royce",
  "Saab",
  "Seat",
  "Škoda",
  "SsangYong",
  "Subaru",
  "Suzuki",
  "Tesla",
  "Toyota",
  "Volkswagen",
  "Volvo",
];

const MyCars = () => {
  const [car, setCar] = useState([]);
  // Arranca en true: el gate del Skeleton es `loading && filteredCars.length === 0`,
  // y el fetch inicial recién pone loading en true dentro del efecto de mount.
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [selectedCar, setSelectedCar] = useState(null);
  const [formErrors, setFormErrors] = useState({});
  const [submitAttempted, setSubmitAttempted] = useState(false);
  const [deleteTargetId, setDeleteTargetId] = useState(null);

  const validateField = (name, value) => {
    const fieldValidation = CAR_FORM_VALIDATION[name];
    if (!fieldValidation) return "";
    return fieldValidation.validate(value);
  };

  // Validar todo el formulario
  const validateForm = (car) => {
    const errors = {};
    let isValid = true;

    Object.keys(CAR_FORM_VALIDATION).forEach((fieldName) => {
      const error = validateField(fieldName, car[fieldName]);
      if (error) {
        errors[fieldName] = error;
        isValid = false;
      }
    });

    return { errors, isValid };
  };

  const handleEditClick = (car) => {
    setSelectedCar(car);
    setFormErrors({});
    setSubmitAttempted(false);
    setOpenModal(true);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSelectedCar(prev => ({ ...prev, [name]: value }));

    if (submitAttempted) {
      const error = validateField(name, value);
      setFormErrors(prev => ({
        ...prev,
        [name]: error
      }));
    }
  };

  const handleSaveEdit = async () => {
    if (!selectedCar) return;

    setSubmitAttempted(true);
    const { errors, isValid } = validateForm(selectedCar);

    if (!isValid) {
      setFormErrors(errors);
      return;
    }

    try {
      const propertyRef = doc(db, "cars", selectedCar.id);
      const docSnap = await getDoc(propertyRef);

      if (!docSnap.exists()) {
        throw new Error("No se encontró el documento del vehículo.");
      }

      await updateDoc(propertyRef, {
        title: selectedCar.title,
        description: selectedCar.description,
        price: selectedCar.price,
        city: selectedCar.city,
        marca: selectedCar.marca,
        km: selectedCar.km,
        año: selectedCar.año,
        modelo: selectedCar.modelo,
        condition: selectedCar.condition,
        images: selectedCar.images,
        whatsapp: (selectedCar.whatsapp || "").trim(),
      });

      handleCloseModal();
    } catch (error) {
      setFormErrors(prev => ({
        ...prev,
        submit: "Error al actualizar el vehículo: " + error.message
      }));
    }
  };

  const handleImageUpload = async (event) => {
    const files = Array.from(event.target.files);

    if (!files.length) return;

    if (selectedCar.images.length + files.length > 10) {
      setFormErrors(prev => ({
        ...prev,
        images: "No puede subir más de 10 imágenes"
      }));
      return;
    }

    setLoading(true);

    try {
      const imageUrls = [];
      for (const file of files) {
        const imageUrl = await uploadImage(file);
        imageUrls.push(imageUrl);
      }

      const updatedImages = [...selectedCar.images, ...imageUrls];
      setSelectedCar(prev => ({
        ...prev,
        images: updatedImages
      }));

      const error = validateField('images', updatedImages);
      setFormErrors(prev => ({
        ...prev,
        images: error
      }));

    } catch (error) {
      setFormErrors(prev => ({
        ...prev,
        images: "Error al subir las imágenes"
      }));
    } finally {
      setLoading(false);
    }
  };

  const handleRemoveImage = (index) => {
    const updatedImages = selectedCar.images.filter((_, i) => i !== index);
    setSelectedCar(prev => ({
      ...prev,
      images: updatedImages
    }));

    if (submitAttempted) {
      const error = validateField('images', updatedImages);
      setFormErrors(prev => ({
        ...prev,
        images: error
      }));
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleDelete = async (carId) => {
    try {
      const carRef = doc(db, "cars", carId);
      await deleteDoc(carRef);
    } catch (error) {
      console.error("Error al eliminar la propiedad:", error);
    } finally {
      setDeleteTargetId(null);
    }
  };


  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedCar(null);
  };

  const formatDate = (timeToDo) => {
    if (timeToDo instanceof Date) {
      return timeToDo.toLocaleDateString();
    } else if (timeToDo && timeToDo.toDate instanceof Function) {
      return timeToDo.toDate().toLocaleDateString();
    }
    return "";
  };

  useEffect(() => {
    const checkAuthAndFetchCars = async () => {
      if (!isLoggedIn()) {
        // Redirect to login page
        return;
      }

      try {
        const token = await getToken();
        if (!token) {
          console.error("No se pudo obtener el token de autenticación.");
          return;
        }

        const currentUser = auth.currentUser;
        if (!currentUser) {
          console.error("No hay un usuario autenticado.");
          return;
        }

        setLoading(true);
        const { uid } = currentUser;
        const q = query(collection(db, "cars"), where("uid", "==", uid));
        const unsubscribe = onSnapshot(q, (snapshot) => {
          const carsData = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          setCar(carsData);
          setLoading(false);
        });
        return () => unsubscribe();
      } catch (error) {
        console.error("Error al obtener vehiculos:", error);
        setLoading(false);
      }
    };
    checkAuthAndFetchCars();
  }, []);


  useEffect(() => {
    const checkAuthAndFetchCars = async () => {
      if (!isLoggedIn()) {
        // Redirect to login page
        return;
      }

      try {
        const token = await getToken();
        if (!token) {
          console.error("No se pudo obtener el token de autenticación.");
          return;
        }

        const currentUser = auth.currentUser;
        if (!currentUser) {
          console.error("No hay un usuario autenticado.");
          return;
        }

        setLoading(true);
        const { uid } = currentUser;
        const q = query(collection(db, "cars"), where("uid", "==", uid));
        const unsubscribe = onSnapshot(q, (snapshot) => {
          const carsData = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          setCar(carsData);
          setLoading(false);
        });
        return () => unsubscribe();
      } catch (error) {
        console.error("Error al obtener vehiculos:", error);
        setLoading(false);
      }
    };
    checkAuthAndFetchCars();
  }, []);



  const filteredCars = car.filter((car) => {
    const searchMatch =
      car.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      car.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
      car.price.toString().includes(searchTerm) ||
      car.city.toString().includes(searchTerm) ||
      car.modelo.toString().includes(searchTerm) ||
      car.año.toString().includes(searchTerm) ||
      car.km.toString().includes(searchTerm) ||
      car.marca.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
      (car.condition &&
        car.condition.toLowerCase().includes(searchTerm.toLowerCase())); // Add condition to search

    return searchMatch;
  });

  const styles = {
    container: {
      mt: 25,
      mb: 20,
    },
  };

  return (
    <Container maxWidth={false} disableGutters sx={pageContentSx}>
      <AppBar position="fixed" sx={{ bgcolor: barColors.background, color: barColors.text }}>
        <Toolbar sx={{ padding: "10px 0" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              width: "100%",
              maxWidth: { xs: "100%", md: "980px" },
              mx: "auto",
              px: 2,
              boxSizing: "border-box",
            }}
          >
            <Atras color="inherit" />
            <Typography variant="h6" sx={{ fontWeight: 500 }}>
              <T>Editar vehículos</T>
            </Typography>
          </Box>
        </Toolbar>
        <Box sx={{ width: "100%", borderTop: `1px solid ${barColors.border}` }}>
          <Toolbar disableGutters sx={{ py: 1.5, px: 0 }}>
            <Box
              sx={{
                width: "100%",
                maxWidth: { xs: "100%", md: "980px" },
                mx: "auto",
                px: 2,
                boxSizing: "border-box",
              }}
            >
              <TextField
                placeholder="Buscar vehículo..."
                value={searchTerm}
                onChange={handleSearchChange}
                variant="outlined"
                size="small"
                fullWidth
                InputProps={{
                  endAdornment: <SearchClearAdornment value={searchTerm} onChange={handleSearchChange} />,
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ color: barColors.textMuted }} />
                    </InputAdornment>
                  ),
                  sx: {
                    color: barColors.text,
                    backgroundColor: barColors.activeBg,
                    borderRadius: "999px",
                    "& fieldset": { border: "none" },
                    "&:hover fieldset": { border: "none" },
                    "&.Mui-focused fieldset": { border: `1px solid ${barColors.border}` },
                  },
                }}
              />
            </Box>
          </Toolbar>
        </Box>
      </AppBar>

      <Container sx={styles.container}>
        {loading ? (
          <Grid container spacing={2} sx={{ mb: 20 }}>
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <Grid item key={i} xs={12} sm={6} md={4} lg={4}>
                <Card
                  sx={{
                    borderRadius: 3,
                    backgroundColor: brandColors.backgroundPaper,
                    border: "1px solid",
                    borderColor: "divider",
                    height: "100%",
                  }}
                >
                  <CardContent>
                    <Stack direction="row" justifyContent="space-between" alignItems="flex-start" spacing={1} sx={{ mb: 1 }}>
                      <Skeleton variant="text" width="60%" height={28} />
                      <Skeleton variant="rounded" width={70} height={24} />
                    </Stack>
                    <Skeleton variant="text" width="100%" height={18} />
                    <Skeleton variant="text" width="90%" height={18} sx={{ mb: 1.5 }} />
                    <Skeleton variant="text" width="35%" height={26} sx={{ mb: 1.5 }} />
                    <Grid container spacing={1.5} sx={{ mb: 1.5 }}>
                      {[1, 2, 3, 4].map((n) => (
                        <Grid item xs={6} key={n}>
                          <Skeleton variant="text" width="60%" height={14} />
                          <Skeleton variant="text" width="80%" height={18} />
                        </Grid>
                      ))}
                    </Grid>
                    <Box sx={{ display: "flex", gap: 1 }}>
                      <Skeleton variant="rounded" width={90} height={90} />
                      <Skeleton variant="rounded" width={90} height={90} />
                    </Box>
                  </CardContent>
                  <CardActions sx={{ px: 2, pb: 2, gap: 1 }}>
                    <Skeleton variant="rounded" width="100%" height={36} />
                    <Skeleton variant="rounded" width="100%" height={36} />
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </Grid>
        ) : filteredCars.length === 0 ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              minHeight: "45vh",
              gap: 1.5,
              color: "text.secondary",
            }}
          >
            <DirectionsCarIcon sx={{ fontSize: 56, color: "text.disabled" }} />
            <Typography sx={{ color: "text.secondary" }}>
              <T>No tenés vehículos publicados todavía.</T>
            </Typography>
          </Box>
        ) : (
          <Grid container spacing={2} sx={{ mb: 20 }}>
            {filteredCars.map((car) => {
              const images = Array.isArray(car.images)
                ? car.images
                : car.images
                ? [car.images]
                : [];
              const conditionStyle = CONDITION_STYLES[car.condition];

              return (
                <Grid item key={car.id} xs={12} sm={6} md={4} lg={4}>
                  <Card
                    sx={{
                      borderRadius: 3,
                      backgroundColor: brandColors.backgroundPaper,
                      border: "1px solid",
                      borderColor: "divider",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <CardContent sx={{ flexGrow: 1 }}>
                      {/* Etiqueta en su propia fila: al lado del título lo dejaba en una columna angosta. */}
                      <Chip
                        size="small"
                        label={conditionStyle ? conditionStyle.label : <T>No especificado</T>}
                        sx={{
                          mb: 1,
                          fontWeight: 600,
                          color: conditionStyle ? conditionStyle.color : "text.secondary",
                          bgcolor: conditionStyle ? conditionStyle.bgcolor : "action.selected",
                        }}
                      />
                      <Typography sx={{ fontSize: 20, fontWeight: 700, mb: 1, lineHeight: 1.4, height: "2.8em", overflowWrap: "anywhere", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" }}>
                        {car.title}
                      </Typography>

                      <Typography
                        sx={{
                          fontSize: 14,
                          color: "text.secondary",
                          mb: 1.5,
                          lineHeight: 1.5,
                          height: "4.5em",
                          display: "-webkit-box",
                          WebkitLineClamp: 3,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                        }}
                      >
                        {car.description}
                      </Typography>

                      <Typography sx={{ fontSize: 20, fontWeight: 700, color: "success.main", mb: 1.5 }}>
                        $ {Number(car.price).toLocaleString()}
                      </Typography>

                      <Grid container spacing={1.5} sx={{ mb: 1.5 }}>
                        {[
                          { label: <T>Marca</T>, value: car.marca },
                          { label: <T>Modelo</T>, value: car.modelo },
                          { label: <T>Año</T>, value: car.año },
                          { label: <T>Km</T>, value: `${car.km} km` },
                          { label: <T>Ciudad</T>, value: car.city },
                        ].map((item, i) => (
                          <Grid item xs={6} key={i}>
                            <Typography sx={{ fontSize: 11, color: "text.secondary" }}>
                              {item.label}
                            </Typography>
                            <Typography sx={{ fontSize: 14, fontWeight: 600, lineHeight: 1.5, minHeight: "1.5em", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                              {item.value}
                            </Typography>
                          </Grid>
                        ))}
                      </Grid>

                      <Typography sx={{ fontSize: 11, color: "text.disabled", mb: 1.5 }}>
                        <T>Publicado el</T> {formatDate(car.createdAt)}
                      </Typography>

                      {images.length > 0 ? (
                        <Box
                          sx={{
                            display: "flex",
                            gap: 1,
                            overflowX: "auto",
                            pb: 0.5,
                            scrollbarWidth: "none",
                            "&::-webkit-scrollbar": { display: "none" },
                          }}
                        >
                          {images.map((image, index) => (
                            <CardMedia
                              key={index}
                              component="img"
                              image={image}
                              alt={`Imagen de ${car.title}`}
                              sx={{ width: 90, height: 90, borderRadius: 2, objectFit: "cover", flexShrink: 0 }}
                            />
                          ))}
                        </Box>
                      ) : (
                        <Box
                          sx={{
                            height: 90,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            borderRadius: 2,
                            backgroundColor: "action.hover",
                            color: "text.disabled",
                          }}
                        >
                          <Typography sx={{ fontSize: 13 }}><T>No hay imágenes</T></Typography>
                        </Box>
                      )}
                    </CardContent>


                    {!car.sourceUrl && <FeatureListingButton collection="cars" listing={car} />}
                    <CardActions sx={{ px: 2, pb: 2, gap: 1 }}>
                      <Button
                        variant="contained"
                        fullWidth
                        startIcon={<EditIcon />}
                        onClick={() => handleEditClick(car)}
                        sx={{ textTransform: "none", bgcolor: brandColors.primary, "&:hover": { bgcolor: brandColors.primaryHover } }}
                      >
                        <T>Editar</T>
                      </Button>
                      <Button
                        variant="outlined"
                        color="error"
                        fullWidth
                        startIcon={<DeleteIcon />}
                        onClick={() => setDeleteTargetId(car.id)}
                        sx={{ textTransform: "none" }}
                      >
                        <T>Eliminar</T>
                      </Button>
                    </CardActions>
                  </Card>
                </Grid>
              );
            })}
          </Grid>
        )}
      </Container>

      <Dialog open={!!deleteTargetId} onClose={() => setDeleteTargetId(null)}>
        <DialogTitle><T>Eliminar vehículo</T></DialogTitle>
        <DialogContent>
          <Typography>
            <T>Esta acción no se puede deshacer. ¿Querés eliminar este vehículo?</T>
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteTargetId(null)}><T>Cancelar</T></Button>
          <Button color="error" variant="contained" onClick={() => handleDelete(deleteTargetId)}>
            <T>Eliminar</T>
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle><T>Editar Vehículo</T></DialogTitle>
        <DialogContent>
          {formErrors.submit && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {formErrors.submit}
            </Alert>
          )}

          <TextField
            autoFocus
            margin="dense"
            name="title"
            label={<T>Título</T>}
            type="text"
            fullWidth
            variant="outlined"
            value={selectedCar?.title || ""}
            onChange={handleInputChange}
            error={!!formErrors.title}
            helperText={formErrors.title}
            required
          />

          <TextField
            margin="dense"
            name="description"
            label={<T>Descripción</T>}
            type="text"
            fullWidth
            multiline
            rows={4}
            variant="outlined"
            value={selectedCar?.description || ""}
            onChange={handleInputChange}
            error={!!formErrors.description}
            helperText={formErrors.description}
            required
          />

          <TextField
            margin="dense"
            name="price"
            label={<T>Precio en USD</T>}
            type="number"
            fullWidth
            variant="outlined"
            value={selectedCar?.price || ""}
            onChange={handleInputChange}
            error={!!formErrors.price}
            helperText={formErrors.price}
            required
          />
          <TextField
            margin="dense"
            name="whatsapp"
            label={<T>WhatsApp de contacto (opcional)</T>}
            type="tel"
            fullWidth
            variant="outlined"
            value={selectedCar?.whatsapp || ""}
            onChange={handleInputChange}
            error={!!formErrors.whatsapp}
            helperText={formErrors.whatsapp || <T>Con código de país, ej: +5491122334455. Se muestra en la publicación con un botón de WhatsApp.</T>}
          />

          <TextField
            margin="dense"
            name="city"
            label={<T>Ciudad</T>}
            type="text"
            fullWidth
            variant="outlined"
            value={selectedCar?.city || ""}
            onChange={handleInputChange}
            error={!!formErrors.city}
            helperText={formErrors.city}
            required
          />

          <TextField
            margin="dense"
            name="modelo"
            label={<T>Modelo</T>}
            type="text"
            fullWidth
            variant="outlined"
            value={selectedCar?.modelo || ""}
            onChange={handleInputChange}
            error={!!formErrors.modelo}
            helperText={formErrors.modelo}
            required
          />

          <TextField
            margin="dense"
            name="año"
            label={<T>Año</T>}
            type="number"
            fullWidth
            variant="outlined"
            value={selectedCar?.año || ""}
            onChange={handleInputChange}
            error={!!formErrors.año}
            helperText={formErrors.año}
            required
          />

          <TextField
            margin="dense"
            name="km"
            label={<T>Kilometraje</T>}
            type="number"
            fullWidth
            variant="outlined"
            value={selectedCar?.km || ""}
            onChange={handleInputChange}
            error={!!formErrors.km}
            helperText={formErrors.km}
            required
          />

          <Typography sx={{ mt: 2 }}><T>Marca:</T></Typography>
          <Select
            name="marca"
            value={selectedCar?.marca || ""}
            onChange={handleInputChange}
            fullWidth
            error={!!formErrors.marca}
            required
            MenuProps={{ sx: { zIndex: 20001 } }}
          >
            <MenuItem value="" disabled><T>Selecciona una marca</T></MenuItem>
            {Marcas.map(marca => (
              <MenuItem key={marca} value={marca}>{marca}</MenuItem>
            ))}
          </Select>
          {formErrors.marca && (
            <FormHelperText error>{formErrors.marca}</FormHelperText>
          )}

          <Typography sx={{ mt: 2 }}><T>Condición del vehículo:</T></Typography>
          <Select
            name="condition"
            value={selectedCar?.condition || ""}
            onChange={handleInputChange}
            fullWidth
            error={!!formErrors.condition}
            required
            MenuProps={{ sx: { zIndex: 20001 } }}
          >
            <MenuItem value="" disabled><T>Selecciona la condición</T></MenuItem>
            <MenuItem value="Nuevo"><T>Nuevo</T></MenuItem>
            <MenuItem value="Usado"><T>Usado</T></MenuItem>
            <MenuItem value="Reparar"><T>Para reparar</T></MenuItem>
          </Select>
          {formErrors.condition && (
            <FormHelperText error>{formErrors.condition}</FormHelperText>
          )}

          {/* Sección de imágenes */}
          {(formErrors?.images || selectedCar?.images?.length === 0) && (
            <Alert
              severity={formErrors?.images ? "error" : "warning"}
              sx={{ mt: 2, mb: 1 }}
            >
              {formErrors?.images || <T>Debe mantener al menos una imagen del vehículo</T>}
            </Alert>
          )}

          <label htmlFor="upload-button" style={{ width: "100%" }}>
            <Button
              variant="contained"
              component="div"
              sx={{ ...uploadButtonSx(!!formErrors?.images), mt: 2 }}
              disabled={loading || (selectedCar?.images?.length >= 10)}
            >
              <AddPhotoAlternateIcon sx={{ color: "white" }} />
              {selectedCar?.images?.length >= 10
                ? <T>Límite de imágenes alcanzado</T>
                : <><T>Subir imagen</T>{selectedCar?.images?.length > 0 ? ` (${selectedCar.images.length}/10)` : 'es'}</>}
              {loading && (
                <CircularProgress size={40} thickness={4} sx={uploadProgressSx} />
              )}
            </Button>
          </label>

          <input
            type="file"
            accept="image/*"
            onChange={handleImageUpload}
            style={{ display: "none" }}
            id="upload-button"
            multiple
          />

          <SortableImageGrid
            images={selectedCar?.images}
            onChange={(images) => setSelectedCar((prev) => ({ ...prev, images }))}
            onRemove={handleRemoveImage}
            hasError={!!formErrors?.images}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal}><T>Cancelar</T></Button>
          <Button
            onClick={handleSaveEdit}
            variant="contained"
            color="primary"
            disabled={loading || Object.keys(formErrors).length > 0}
          >
            {loading ? <CircularProgress size={24} sx={{ mr: 1 }} /> : null}
            <T>Guardar</T>
          </Button>
        </DialogActions>
      </Dialog>

      <BottomNav />
    </Container>
  );
};

// Función de utilidad para formatear la fecha


export default MyCars;
